import { Col, Row } from "antd";
import { matchPath, useHistory } from "react-router-dom";
import { FC, useEffect } from "react";
import "./companyProfile.less";
import { IRoute, paths, Routes } from "@router";
import Tabs from "@components/Tabs";
import { tabs } from "./config";
import { checkPermission } from "@/utils";
import { permissions } from "@/router";
import { useTypedSelector } from "@/hooks";
import { useState } from "react";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { useFetchCompaniesQuery } from "@services";
import { setSelectedCompanyInStorage } from "@/services/global-storage";
import { ICompany } from "@/types";
import CompanySelectCarousel from "@components/caurosel";
import "./companyProfile.less";
import { useLocation } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";
import CompanyList from "@/components/List/company-list";

interface ICompanyProfile {
  routes: IRoute[];
}

const ClientCompanyProfile: FC<ICompanyProfile> = ({ routes }) => {
  const { user, permissions: per } = useTypedSelector(state => state.auth);

  const location = useLocation();
  const history = useHistory();
  const match = matchPath(window.location.pathname, {
    path: paths.client.users.companies.profile.business_units.regions,
  });
  const [
    page,
    // setPage
  ] = useState(1);
  const [isCompanySelected, setIsCompanySelected] = useState<boolean>(false);
  // const [selectedCompany, setselectedCompany] = useState<ICompany>();
  const [selectedCompany, setselectedCompany] = useState<any>(null);

  const { data: companiesData, isLoading: isFetching } =
    useFetchCompaniesQuery(page);
  const { data } = companiesData || {};

  const onPressNext = (companyId: any) => {
    setIsCompanySelected(true);
    history.push(`${paths.client.users.companies.listing}/${companyId}`);
  };

  const createNewCompany = () =>
    history.push(paths.admin.users.companies.create);

  let handleCompanySelect = (company: ICompany) => {
    setselectedCompany(company);
    setSelectedCompanyInStorage(company);
    onPressNext(company);
  };

  useEffect(() => {
    const isRootCompanyPage =
      location.pathname === paths.client.users.companies.listing;
    if (isRootCompanyPage) {
      setIsCompanySelected(false);
      setselectedCompany(undefined);
    }
  }, [location.pathname]);

  if (!isCompanySelected && !user?.company?.id) {
    return (
      <div className="ApplicationSelector  w-full px-12">
        <div className="flex justify-between items-center mt-6 px-4">
          <h2 className="font-bold text-xl text-themeBlue text-left">
            Select the Company
          </h2>

          {(per.includes("CREATE_COMPANY") || per.includes("all")) && (
            <button
              onClick={createNewCompany}
              type="button"
              className="flex items-center justify-center py-2 px-5 rounded-md text-sm font-semibold text-white bg-themeBlue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-themeBlue"
            >
              Create New Company
            </button>
          )}
        </div>

        {isFetching ? (
          <div
            style={{ height: "650px" }}
            className="flex justify-center items-center "
          >
            <LoadingOutlined
              className="spinner "
              style={{ fontSize: "80px" }}
            />
          </div>
        ) : (
          <>
            <main className="min-h-screen bg-background flex items-center justify-center p-4">
              <div className="w-full ">
                <CompanyList
                  companiesList={data && data}
                  onSelectCompany={setselectedCompany}
                  selectedCompany={selectedCompany}
                />

                {selectedCompany && (
                  <div className="mt-8 flex gap-2  sticky bottom-2">
                    <button
                      onClick={() => handleCompanySelect(selectedCompany)}
                      className="flex-1 bg-themeBlue text-white px-5 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
                    >
                      {
                        data?.find((item: any) => item?.id == selectedCompany)
                          ?.name
                      }
                      <BiChevronRight className="w-4 h-4" />
                    </button>
                  </div>
                )}
              </div>
            </main>
          </>
        )}
      </div>
    );
  }
  return (
    <div>
      {checkPermission([
        permissions.VIEW_BUSINESS_UNIT,
        permissions.VIEW_REGION,
      ]) ? (
        <div className="companyProfile">
          {match ? null : (
            <>
              <Row>
                <Col span={24}>
                  <div className="main-heading mb-16"></div>
                </Col>
              </Row>
              <Tabs
                param=":company_id"
                route={true}
                paramValue={
                  user?.company?.id
                    ? `${user?.company?.id}`
                    : `${selectedCompany}`
                }
                tabs={tabs}
              />
            </>
          )}
          <div className="companyProfile__content">
            <Routes routes={routes} />
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default ClientCompanyProfile;
